import { FC } from "react";
import { useDevice } from "common/hooks/useDevice";
import { StyledAvatar, DefaultAvatar } from "./Avatar.styled";

interface Props {
  authors?: {
    imageUrl: string;
  }[];
  user?: any;
}
const Avatar: FC<Props> = ({ authors, user }) => {
  const { screenSize } = useDevice();
  if (user) {
    return <DefaultAvatar>{user}</DefaultAvatar>;
  }
  if (screenSize.medium || !authors) {
    return null;
  }

  const { imageUrl } = authors[0];
  if (!imageUrl) {
    return null;
  }

  return <StyledAvatar src={imageUrl} alt="" />;
};
export default Avatar;
